module.exports = __webpack_public_path__ + "img/481f463b79644f97a8756abd60a92109.b2202761.png";